module.exports = __webpack_public_path__ + "static/img/piz_bcg3.22bd7fe6.png";